module.exports = __webpack_public_path__ + "img/16n.fbf421eb.png";